// #region PRIVACY POLICY
export const privacyTitle = "BOstages Privacy Policy";

export const privacyVersion = "v1.0";

export const privacyEffectiveDate = "01/09/2026";

export const privacyLastUpdated = "02/09/2026";

export const privacyPolicyDownloadLink = null;

export const privacyPolicyIntroData = [
    "This Privacy Policy explains how BOtag Norge AS processes personal data as controller in connection with BOstages, BOtag websites, subscriptions, customer administration, billing, support, NanaBO, PIMP, BOimages, integrations, acceptance logs, demo requests, and related business operations.",
    "This Privacy Policy is published in English. If a Norwegian translation is later made available and there is a conflict between versions, the English version controls unless mandatory law requires otherwise."
];

export const privacyPolicyData = [
    {
        "title": "1. Who we are",
        "blocks": [
            {
                "t": "p",
                "text": "**Data controller**"
            },
            {
                "t": "lines",
                "lines": [
                    "BOtag Norge AS",
                    "Reg. no.: 932 017 814",
                    "VAT: 932 017 814 MVA",
                    "Tordenskiolds gate 2, 0160 Oslo, Norway",
                    "Privacy contact: support@botag.no",
                    "Website: https://botag.no"
                ]
            },
            {
                "t": "p",
                "text": "In this Privacy Policy, “BOtag”, “we”, “us”, and “our” mean BOtag Norge AS."
            },
            {
                "t": "p",
                "text": "BOtag Norge AS is a wholly owned subsidiary of BOtag Technology BV in the Netherlands. BOtag Technology BV may support BOtag Norge AS with group administration, governance, finance, product, security, technical, operational, and management activities where necessary."
            },
            {
                "t": "p",
                "text": "BOtag Norge AS remains the controller for the processing described in this Privacy Policy unless otherwise stated."
            }
        ]
    },
    {
        "title": "2. Scope of this Privacy Policy",
        "blocks": [
            {
                "t": "p",
                "text": "This Privacy Policy applies when BOtag processes personal data as controller, including when you:"
            },
            {
                "t": "ul",
                "items": [
                    "use or visit BOtag or BOstages websites;",
                    "submit a demo request, contact form, support request, or other enquiry;",
                    "create or use a BOstages account;",
                    "subscribe to, purchase, or evaluate BOstages;",
                    "use BOstageA, BOstageB, BOstageR, BOstageG, BOstageX, NanaBO, PIMP, BOimages, APIs, integrations, or related services;",
                    "accept BOstages Terms & Conditions, the Data Processing Agreement, a side agreement, an offer, or other commercial terms;",
                    "are listed as an account, billing, legal, technical, security, support, supplier, retail, store, or business contact."
                ]
            },
            {
                "t": "p",
                "text": "This Privacy Policy does not govern Customer Personal Data that BOtag processes on behalf of a BOstages customer as processor. That processing is governed by the applicable customer agreement and the BOstages Data Processing Agreement."
            },
            {
                "t": "p",
                "text": "Third-party websites, POS systems, commerce platforms, payment providers, integrations, and external services may have their own privacy policies."
            }
        ]
    },
    {
        "title": "3. Personal data we process",
        "blocks": [
            {
                "t": "cards",
                "cards": [
                    {
                        "title": "Account and user data",
                        "text": "Name, work email, phone number, role or title, company name, organisation number, business address, user ID, account settings, permissions and roles, login information, authentication and access records, language and interface preferences."
                    },
                    {
                        "title": "Subscription, billing, and commercial data",
                        "text": "Selected plan, subscription status, billing frequency, pricing and discounts, custom pricing, commitment periods, side agreements, accepted offers, purchase history, payment status, invoice, receipt, VAT/tax and payment-confirmation information, billing contact details, cancellation and renewal status."
                    },
                    {
                        "title": "Acceptance and contract logs",
                        "text": "Company ID, user ID, user email, timestamp, IP address, accepted document version, document links or identifiers, acceptance method, selected plan, and confirmation that the accepting user is authorised to bind the Customer."
                    },
                    {
                        "title": "Website, demo, and contact data",
                        "text": "IP address, user agent, requested URL or page, HTTP headers, technical request metadata, name, work email, country, company name, message content, originating page, interface language, submission timestamp, and anti-abuse or rate-limit information."
                    },
                    {
                        "title": "Support and communication data",
                        "text": "Support requests, email messages, in-app messages, NanaBO support interactions, screenshots or files you choose to send, technical diagnostics, support notes, and communication history."
                    },
                    {
                        "title": "BOstages operational data",
                        "text": "Audit logs, workspace metadata, integration metadata, API logs, error logs, security logs, usage events, import and export status, validation results, generated-file metadata, workflow and job metadata."
                    },
                    {
                        "title": "NanaBO, PIMP, BOimages, and AI-assisted data",
                        "text": "NanaBO messages, prompts and responses, workflow instructions, uploaded files selected for processing, PIMP mappings, validation reports, product-data review outputs, BOimages metadata, generated files, audit logs, AI-assisted summaries, explanations, recommendations, or support outputs."
                    },
                    {
                        "title": "Images and uploaded content",
                        "text": "BOimages, uploaded product images, support attachments, or other Customer files may contain identifiable individuals. BOstages is not designed for unnecessary sensitive personal data."
                    }
                ]
            }
        ]
    },
    {
        "title": "4. Sources of personal data",
        "blocks": [
            {
                "t": "p",
                "text": "We may collect personal data from:"
            },
            {
                "t": "ul",
                "items": [
                    "you directly;",
                    "your employer or company;",
                    "Customer administrators and other authorised Customer users;",
                    "subscription checkout, Billing page, or account flows;",
                    "support requests and communications;",
                    "BOstages system logs;",
                    "customer-authorised integrations;",
                    "payment and billing providers;",
                    "public business sources where relevant;",
                    "BOtag Technology BV or other group support functions where relevant;",
                    "service providers used to operate BOstages."
                ]
            }
        ]
    },
    {
        "title": "5. Why we process personal data and legal bases",
        "blocks": [
            {
                "t": "cards",
                "cards": [
                    {
                        "title": "Provide and operate BOstages",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Accounts, access, subscriptions, workflows, support, integrations, APIs."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Contract or legitimate interests."
                            }
                        ]
                    },
                    {
                        "title": "Manage customer relationships",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Onboarding, customer administration, account management, communication."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Contract or legitimate interests."
                            }
                        ]
                    },
                    {
                        "title": "Billing and payments",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Invoices, receipts, payment status, tax/VAT, overdue amounts."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Contract, legal obligation, legitimate interests."
                            }
                        ]
                    },
                    {
                        "title": "Acceptance and contract proof",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Terms/DPA acceptance logs, authority confirmation, side agreements, accepted offers."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Contract, legitimate interests, legal claims."
                            }
                        ]
                    },
                    {
                        "title": "Security and abuse prevention",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Access logs, audit logs, rate limits, fraud/misuse detection, cross-tenant protection."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Legitimate interests, legal obligation where applicable."
                            }
                        ]
                    },
                    {
                        "title": "Support and troubleshooting",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Support tickets, diagnostics, communication, error handling."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Contract or legitimate interests."
                            }
                        ]
                    },
                    {
                        "title": "NanaBO, PIMP, BOimages, and workflows",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Operational assistance, validation, mapping, summaries, generated outputs."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Contract or legitimate interests."
                            }
                        ]
                    },
                    {
                        "title": "Service improvement",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Product analytics, debugging, quality improvement, aggregated/anonymised insights."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Legitimate interests."
                            }
                        ]
                    },
                    {
                        "title": "Marketing and demos",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Demo handling, B2B follow-up, service updates, event/contact follow-up."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Legitimate interests or consent where required."
                            }
                        ]
                    },
                    {
                        "title": "Legal and compliance",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Accounting, tax, claims, regulatory requests, audits, recordkeeping."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Legal obligation or legitimate interests."
                            }
                        ]
                    },
                    {
                        "title": "Group administration",
                        "rows": [
                            {
                                "label": "Examples",
                                "value": "Governance, finance, reporting, security, product, technical and operational support by BOtag Technology BV."
                            },
                            {
                                "label": "Legal basis",
                                "value": "Legitimate interests."
                            }
                        ]
                    }
                ]
            },
            {
                "t": "p",
                "text": "Where we rely on legitimate interests, our interests include operating a secure and reliable B2B platform, managing customer relationships, preventing abuse, improving our services, responding to business enquiries, documenting commercial agreements, and protecting BOtag, customers, users, systems, and third parties."
            },
            {
                "t": "p",
                "text": "Where consent is required, we will ask for consent separately. You may withdraw consent at any time, without affecting processing that took place before withdrawal."
            }
        ]
    },
    {
        "title": "6. When personal data is required",
        "blocks": [
            {
                "t": "p",
                "text": "Some personal data is necessary to create an account, provide BOstages, manage subscriptions, verify authority, issue receipts or invoices, provide support, handle security, or comply with legal requirements."
            },
            {
                "t": "p",
                "text": "If required data is not provided, BOtag may be unable to provide the relevant service, account, subscription, support, demo, or commercial arrangement."
            }
        ]
    },
    {
        "title": "7. Customer Personal Data and the DPA",
        "blocks": [
            {
                "t": "p",
                "text": "BOstages customers may upload or generate data that contains personal data. Examples may include user names, business contact details, store contacts, buyer contacts, supplier contacts, delivery contacts, support messages, audit logs, uploaded files, order files, POS payloads, or identifiable images."
            },
            {
                "t": "p",
                "text": "Where BOtag processes such Customer Personal Data on behalf of the Customer, the Customer is normally the controller and BOtag is normally the processor. That processing is governed by the BOstages Data Processing Agreement."
            },
            {
                "t": "p",
                "text": "BOtag may process limited account, security, billing, acceptance-log, support, and service-operation data as an independent controller, as described in this Privacy Policy."
            }
        ]
    },
    {
        "title": "8. NanaBO and AI-assisted features",
        "blocks": [
            {
                "t": "p",
                "text": "NanaBO and related AI-assisted features may help with operational workflows, file understanding, mapping support, validation explanations, summaries, product-data review, Buying Intelligence, and support."
            },
            {
                "t": "p",
                "text": "AI-assisted outputs may be incomplete, inaccurate, outdated, or unsuitable for a specific purpose. Customers are responsible for reviewing outputs before relying on them."
            },
            {
                "t": "p",
                "text": "BOtag does not use Customer content to train public AI models unless expressly agreed in writing."
            },
            {
                "t": "p",
                "text": "Where a third-party AI provider processes Customer Personal Data on behalf of BOtag, that provider will be handled under the Data Processing Agreement and subprocessor process where applicable."
            },
            {
                "t": "p",
                "text": "BOtag may log NanaBO interactions for support, security, auditability, troubleshooting, service operation, and service improvement according to this Privacy Policy and the Data Processing Agreement."
            }
        ]
    },
    {
        "title": "9. Cookies and similar technologies",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag websites may use cookies and similar technical storage to deliver and protect websites, maintain sessions, prevent abuse, remember technical preferences, and measure or improve website performance."
            },
            {
                "t": "p",
                "text": "If BOtag uses non-essential analytics, advertising, tracking pixels, or behavioural advertising technologies, BOtag will provide information and obtain consent where required by law."
            },
            {
                "t": "p",
                "text": "A separate cookie notice or cookie banner may provide more detailed information about cookies and similar technologies used on a specific website."
            }
        ]
    },
    {
        "title": "10. Sharing, recipients, and providers",
        "blocks": [
            {
                "t": "p",
                "text": "We may share personal data with:"
            },
            {
                "t": "ul",
                "items": [
                    "BOtag Technology BV in the Netherlands for group administration, governance, finance, security, product, technical, operational, and management support;",
                    "hosting, cloud, infrastructure, database, backup, storage, email, support, communication, payment, billing, accounting, monitoring, logging, security, and error-tracking providers;",
                    "professional advisers, auditors, accountants, legal advisers, and insurers;",
                    "customer-authorised integration providers;",
                    "authorities, courts, regulators, law-enforcement bodies, or other recipients where required or permitted by law;",
                    "successors or acquirers in connection with a merger, restructuring, investment, sale of assets, or similar transaction."
                ]
            },
            {
                "t": "p",
                "text": "We do not sell personal data."
            },
            {
                "t": "p",
                "text": "Providers named in BOtag’s current BOstages DPA/provider materials may include Microsoft / Azure, Stripe, OpenAI or another AI provider where enabled or approved, and customer-authorised integrations such as Front Systems, Traze, Spy System, and Shopify. Customer-authorised integrations are not automatically BOtag subprocessors; their role depends on the Customer’s relationship with them and the integration structure."
            },
            {
                "t": "p",
                "text": "Provider use may change as BOtag’s services, websites, and infrastructure evolve. When BOtag processes Customer Personal Data as processor, subprocessors are handled under the BOstages Data Processing Agreement."
            }
        ]
    },
    {
        "title": "11. International transfers",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag is established in Norway. BOtag Technology BV is established in the Netherlands. Transfers within Norway and the EEA are not third-country transfers under GDPR."
            },
            {
                "t": "p",
                "text": "Some providers may process personal data outside Norway or the EEA. Where personal data is transferred outside the EEA and GDPR Chapter V applies, BOtag uses a lawful transfer mechanism such as an adequacy decision, Standard Contractual Clauses, supplementary measures where required, or another lawful mechanism."
            },
            {
                "t": "p",
                "text": "You may contact us at support@botag.no for information about safeguards relevant to a particular processing activity."
            }
        ]
    },
    {
        "title": "12. Retention",
        "blocks": [
            {
                "t": "p",
                "text": "We keep personal data only for as long as necessary for the purpose for which it was collected, unless longer retention is required or permitted by law."
            },
            {
                "t": "cards",
                "cards": [
                    {
                        "title": "Account and customer administration data",
                        "rows": [
                            {
                                "label": "Typical retention approach",
                                "value": "For the duration of the customer relationship and thereafter as needed for legal, security, accounting, dispute, and compliance purposes."
                            }
                        ]
                    },
                    {
                        "title": "Acceptance logs and contract records",
                        "rows": [
                            {
                                "label": "Typical retention approach",
                                "value": "For the duration of the agreement and thereafter as needed to document acceptance, authority, legal claims, and compliance."
                            }
                        ]
                    },
                    {
                        "title": "Billing, invoice, receipt, and accounting data",
                        "rows": [
                            {
                                "label": "Typical retention approach",
                                "value": "As required by applicable Norwegian accounting, tax, and bookkeeping rules."
                            }
                        ]
                    },
                    {
                        "title": "Support and communication data",
                        "rows": [
                            {
                                "label": "Typical retention approach",
                                "value": "For as long as necessary to handle the request and for reasonable follow-up, security, quality, legal, and dispute purposes."
                            }
                        ]
                    },
                    {
                        "title": "Demo requests that do not become customer relationships",
                        "rows": [
                            {
                                "label": "Typical retention approach",
                                "value": "Normally up to 12 months after the last meaningful contact unless longer retention is required for legal, security, fraud, or compliance reasons."
                            }
                        ]
                    },
                    {
                        "title": "Technical and security logs",
                        "rows": [
                            {
                                "label": "Typical retention approach",
                                "value": "According to operational necessity and provider configurations, and not longer than necessary for security, operations, troubleshooting, abuse prevention, or compliance."
                            }
                        ]
                    },
                    {
                        "title": "Customer Personal Data under the DPA",
                        "rows": [
                            {
                                "label": "Typical retention approach",
                                "value": "Handled according to the Data Processing Agreement, including export/return, deletion, backup, and audit-log rules."
                            }
                        ]
                    }
                ]
            },
            {
                "t": "p",
                "text": "Anonymised data may be retained and used where it no longer identifies the Customer, users, or individuals. Pseudonymised data remains personal data where it can reasonably be linked back to an individual."
            }
        ]
    },
    {
        "title": "13. Security",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag applies technical and organisational measures intended to protect personal data from unauthorised access, loss, alteration, disclosure, or destruction."
            },
            {
                "t": "p",
                "text": "Measures may include tenant isolation, role-based access control, customer admin controls, restricted production access, confidentiality obligations, secure hosting arrangements, audit logs, backup routines, monitoring, incident response, harmful-file handling, and measures to protect against unauthorised cross-tenant access."
            },
            {
                "t": "p",
                "text": "No method of transmission or storage is completely risk-free, but BOtag applies safeguards appropriate to the nature, scope, context, and purpose of the processing."
            }
        ]
    },
    {
        "title": "14. Your rights",
        "blocks": [
            {
                "t": "p",
                "text": "Subject to the conditions and exceptions in applicable data-protection law, you may have the right to:"
            },
            {
                "t": "ul",
                "items": [
                    "obtain information about and access to your personal data;",
                    "request correction of inaccurate or incomplete data;",
                    "request deletion;",
                    "request restriction of processing;",
                    "object to processing based on legitimate interests;",
                    "withdraw consent where processing is based on consent;",
                    "receive personal data in a portable format where the legal requirements for data portability apply;",
                    "not be subject to solely automated decisions with legal or similarly significant effects where GDPR gives such a right;",
                    "lodge a complaint with a competent supervisory authority."
                ]
            },
            {
                "t": "p",
                "text": "Because some processing is based on legitimate interests, you may object on grounds relating to your particular situation."
            },
            {
                "t": "p",
                "text": "To exercise your rights, contact support@botag.no. We may need information reasonably necessary to verify your identity before acting on a request."
            }
        ]
    },
    {
        "title": "15. Automated decision-making",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag does not use the public website, demo request flow, subscription process, NanaBO, PIMP, Buying Intelligence, or BOstages operational features to make decisions about individuals based solely on automated processing that produce legal or similarly significant effects."
            },
            {
                "t": "p",
                "text": "BOstages may provide business decision-support outputs, such as product-data validation, summaries, recommendations, forecasts, Buying Intelligence, or Commercial Outcome Estimates. These are operational tools for business users and are not automated decisions about individuals."
            }
        ]
    },
    {
        "title": "16. Marketing communications",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag may send service-related communications, transactional messages, subscription notices, security notices, legal notices, and support communications."
            },
            {
                "t": "p",
                "text": "BOtag may send B2B marketing or product-update communications where permitted by law, based on legitimate interests or consent where required."
            },
            {
                "t": "p",
                "text": "You may opt out of marketing communications where applicable. Service, security, legal, billing, and transactional messages may still be sent where necessary."
            }
        ]
    },
    {
        "title": "17. Children and sensitive data",
        "blocks": [
            {
                "t": "p",
                "text": "BOstages is a B2B platform and is not intended for children or consumer use."
            },
            {
                "t": "p",
                "text": "BOstages is not designed for unnecessary sensitive personal data. Customers must not upload special-category personal data, national identity numbers, payment-card data, health data, criminal offence data, children’s data, biometric data, private HR records, patient data, citizen data, healthcare data, school data, or similar high-risk data unless expressly agreed in writing and legally permitted."
            },
            {
                "t": "p",
                "text": "If such data is uploaded without approval, BOtag may delete, quarantine, restrict, or return it where reasonably necessary."
            }
        ]
    },
    {
        "title": "18. Complaints",
        "blocks": [
            {
                "t": "p",
                "text": "If you believe BOtag’s processing of your personal data infringes applicable data-protection law, please contact us first so we can review the matter."
            },
            {
                "t": "p",
                "text": "You also have the right to lodge a complaint with the Norwegian Data Protection Authority, Datatilsynet, or another competent supervisory authority where applicable."
            }
        ]
    },
    {
        "title": "19. Changes to this Privacy Policy",
        "blocks": [
            {
                "t": "p",
                "text": "We may update this Privacy Policy when our services, websites, processing activities, providers, group structure, legal documents, or legal requirements change."
            },
            {
                "t": "p",
                "text": "The current version and last-updated date will be shown on this page."
            },
            {
                "t": "p",
                "text": "If a change materially affects how we process personal data, we will provide appropriate additional notice where required."
            }
        ]
    },
    {
        "title": "20. Contact",
        "blocks": [
            {
                "t": "p",
                "text": "For privacy questions or to exercise your rights:"
            },
            {
                "t": "lines",
                "lines": [
                    "BOtag Norge AS",
                    "Tordenskiolds gate 2",
                    "0160 Oslo",
                    "Norway",
                    "support@botag.no"
                ]
            }
        ]
    }
];
// #endregion

// #region TERMS AND CONDITIONS
export const termsAndConditionsTitle = "BOstages Terms & Conditions";

export const termsAndConditionsVersion = "v7";

export const termsAndConditionsEffectiveDate = "02/09/2026";

export const termsAndConditionsLastUpdated = "02/09/2026";

export const termsAndConditionsDownloadLink = null;

export const termsAndConditionsIntroData = [
    "These Terms are published in English. If a Norwegian translation is later made available and there is a conflict between versions, the English version controls unless mandatory law requires otherwise."
];

export const termsAndConditionsData = [
    {
        "title": "1. Provider",
        "blocks": [
            {
                "t": "p",
                "text": "These Terms & Conditions are issued by:"
            },
            {
                "t": "lines",
                "lines": [
                    "BOtag Norge AS",
                    "Reg. no.: 932 017 814",
                    "VAT: 932 017 814 MVA",
                    "Tordenskiolds gate 2, 0160 Oslo, Norway",
                    "support@bostages.com",
                    "bostages.com"
                ]
            },
            {
                "t": "p",
                "text": "In these Terms, \"BOtag\", \"we\", \"us\", or \"our\" means BOtag Norge AS."
            }
        ]
    },
    {
        "title": "2. Acceptance",
        "blocks": [
            {
                "t": "p",
                "text": "These Terms apply to the company or organisation using BOstages."
            },
            {
                "t": "p",
                "text": "By clicking \"I accept\", creating an account, using BOstages, signing a separate written agreement, or continuing to use BOstages after updated Terms take effect, the Customer accepts these Terms."
            },
            {
                "t": "p",
                "text": "The person accepting these Terms confirms that they are authorised to bind the Customer."
            },
            {
                "t": "p",
                "text": "BOtag may record acceptance details, including company ID, user ID, user email, timestamp, IP address, accepted document version, acceptance method, selected plan, and confirmation that the accepting user is authorised to bind the Customer."
            },
            {
                "t": "p",
                "text": "BOstages is a business-to-business platform and is not intended for consumer use."
            }
        ]
    },
    {
        "title": "3. Agreement documents",
        "blocks": [
            {
                "t": "p",
                "text": "The agreement between BOtag and the Customer may include these Terms, a separate written agreement, the Privacy Policy, the Data Processing Agreement, service descriptions, and any other document accepted or signed by the Parties."
            },
            {
                "t": "p",
                "text": "If documents conflict, the order of priority is:"
            },
            {
                "t": "ol",
                "items": [
                    "a separate written agreement signed by both Parties;",
                    "the Data Processing Agreement, but only for personal-data processing matters;",
                    "these Terms;",
                    "service descriptions, product pages, or documentation."
                ]
            },
            {
                "t": "p",
                "text": "Enterprise customers may agree different terms in a separate written agreement signed by both Parties."
            }
        ]
    },
    {
        "title": "4. Services",
        "blocks": [
            {
                "t": "p",
                "text": "BOstages includes BOtag's business-to-business platform and related services, including BOstageA, BOstageB, BOstageR, BOstageG, BOstageX, NanaBO, PIMP, BOimages, APIs, integrations, onboarding, and support."
            },
            {
                "t": "p",
                "text": "BOstageB and PIMP support product-data imports, product masters, EAN/barcode sheets, PDFs, order files, validation, mapping, audit logs, and related workflows."
            },
            {
                "t": "p",
                "text": "NanaBO is an AI-assisted operational feature of BOstages. NanaBO may help users understand workflows, trigger actions, review validation results, and interact with backend workers."
            },
            {
                "t": "p",
                "text": "Some features may be beta, pilot, preview, or experimental. Such features may be changed, limited, suspended, or discontinued at any time and are provided without service-level commitment unless agreed in writing."
            },
            {
                "t": "p",
                "text": "BOstages is not a legal, financial, tax, medical, HR, employment, or regulated advisory service."
            }
        ]
    },
    {
        "title": "5. Accounts and customer responsibilities",
        "blocks": [
            {
                "t": "p",
                "text": "The Customer is responsible for:"
            },
            {
                "t": "ul",
                "items": [
                    "all activity under its accounts;",
                    "managing users, roles, permissions, and access removal;",
                    "keeping admin, billing, legal, and security contact details updated;",
                    "using the Services securely;",
                    "ensuring Customer Data is lawful, accurate, and authorised for use;",
                    "having rights to upload product data, images, brand assets, files, order data, POS data, and integration data;",
                    "reviewing PIMP, NanaBO, AI-assisted, import, mapping, validation, and export outputs before relying on them;",
                    "maintaining valid credentials, API keys, and access rights for third-party integrations;",
                    "ensuring connected third-party systems may lawfully receive and process Customer Data."
                ]
            },
            {
                "t": "p",
                "text": "BOtag may rely on instructions, approvals, uploads, configurations, and actions performed through authorised Customer accounts."
            }
        ]
    },
    {
        "title": "6. Fees and payment",
        "blocks": [
            {
                "t": "p",
                "text": "Unless otherwise agreed in a separate written agreement:"
            },
            {
                "t": "ul",
                "items": [
                    "subscriptions are prepaid quarterly or annually;",
                    "access to paid Services begins after payment has been successfully completed or otherwise approved by BOtag;",
                    "fees are exclusive of VAT and other taxes;",
                    "fees are non-refundable unless required by law or expressly agreed in writing;",
                    "BOtag may issue a receipt, invoice, or payment confirmation after payment;",
                    "startup, onboarding, project, integration, import-assistance, or custom-work fees may be charged separately."
                ]
            },
            {
                "t": "p",
                "text": "BOtag may offer discounts, promotional pricing, custom pricing, commitment periods, billing frequencies, usage allowances, or other customer-specific commercial terms through the subscription checkout, Billing page, approved offer, separate written agreement, or another acceptance method approved by BOtag."
            },
            {
                "t": "p",
                "text": "Where customer-specific commercial terms are accepted by the Customer, those terms apply to the affected subscription and override conflicting standard pricing, public pricing, Billing page information, checkout information, or service-description information for that subscription only."
            },
            {
                "t": "p",
                "text": "Unless otherwise stated in the accepted customer-specific commercial terms, fees remain exclusive of VAT and other taxes, are billed in advance, and are non-refundable unless required by law or expressly agreed in writing."
            },
            {
                "t": "p",
                "text": "If a subscription renewal payment fails or remains unpaid, BOtag may notify the Customer. If the amount remains unpaid 14 days after written reminder, BOtag may suspend access until payment is received."
            },
            {
                "t": "p",
                "text": "Late payment interest and collection costs may apply according to applicable Norwegian law where relevant."
            },
            {
                "t": "p",
                "text": "BOtag may adjust subscription fees annually on 1 January in line with the Norwegian consumer price index or a similar relevant index."
            },
            {
                "t": "p",
                "text": "If BOtag offers a free trial, pilot, or promotional period, the applicable duration, limitations, cancellation options, and conversion terms will be shown in the subscription checkout, Billing page, or separate written agreement."
            },
            {
                "t": "p",
                "text": "BOtag may otherwise change pricing, packaging, or usage limits with at least 60 days' notice. Price changes apply from the next renewal period unless otherwise agreed."
            }
        ]
    },
    {
        "title": "7. Subscription term and termination",
        "blocks": [
            {
                "t": "p",
                "text": "Subscriptions run for the period selected by the Customer in the subscription checkout, shown on the Billing page, or stated in a separate written agreement. If no subscription period is stated, the subscription period is quarterly."
            },
            {
                "t": "p",
                "text": "Subscriptions renew automatically unless terminated before renewal."
            },
            {
                "t": "p",
                "text": "The Customer may terminate a subscription before renewal by using the \"Cancel a subscription\" button on the Billing page, where available, or by contacting support@bostages.com before the renewal date."
            },
            {
                "t": "p",
                "text": "Cancellation requests received after a renewal has been processed apply to the next renewal period unless BOtag agrees otherwise or applicable law requires otherwise."
            },
            {
                "t": "p",
                "text": "Termination takes effect at the end of the then-current subscription period. Termination prevents renewal but does not entitle the Customer to a refund for the remaining paid period unless required by law or agreed in writing."
            },
            {
                "t": "p",
                "text": "For quarterly subscriptions, termination takes effect at the end of the current paid quarter."
            },
            {
                "t": "p",
                "text": "For annual subscriptions, termination takes effect at the end of the current paid annual period."
            },
            {
                "t": "p",
                "text": "If the Customer accepts a minimum commitment period, the subscription cannot be terminated for convenience before the end of that commitment period. Termination during the commitment period prevents renewal after the commitment period but does not release the Customer from payment obligations for the remaining committed period, unless required by law or expressly agreed in writing."
            },
            {
                "t": "p",
                "text": "Where a subscription is subject to a commitment period but billed in instalments, such as quarterly billing during a 12-month commitment, all instalments for the commitment period remain payable unless otherwise agreed in writing."
            },
            {
                "t": "p",
                "text": "If a renewal payment fails, access to paid Services may be suspended or downgraded according to Section 6."
            },
            {
                "t": "p",
                "text": "Any unpaid amounts for approved manual subscriptions, separate written agreements, onboarding, startup, project work, integrations, import assistance, custom work, chargebacks, or other agreed paid services remain payable after termination."
            },
            {
                "t": "p",
                "text": "BOtag may suspend or restrict access to the Services immediately if BOtag reasonably believes that the Customer's breach creates security risk, legal risk, operational risk, platform risk, cross-tenant risk, payment abuse risk, violates Section 12, involves unlawful use, attempts unauthorised access, uploads harmful content, or is not reasonably capable of cure."
            },
            {
                "t": "p",
                "text": "For other material breaches, BOtag may suspend or terminate the affected Services if the Customer does not cure the breach within 7 business days after written notice."
            },
            {
                "t": "p",
                "text": "BOtag may terminate the Services immediately where continued provision of the Services would expose BOtag, the Services, other customers, or third parties to material legal, security, operational, or platform risk."
            },
            {
                "t": "p",
                "text": "After termination, Customer Data and Customer Personal Data are handled according to the Data Processing Agreement, Privacy Policy, and applicable retention rules."
            }
        ]
    },
    {
        "title": "8. Availability, maintenance, and support",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag will use commercially reasonable efforts to target 99.9% monthly availability for the production parts of BOstages under BOtag's reasonable control."
            },
            {
                "t": "p",
                "text": "The availability target does not apply to scheduled maintenance, emergency maintenance, beta features, free trials, Customer-side issues, third-party services, Customer-authorised integrations, internet or cloud incidents outside BOtag's reasonable control, force majeure, or suspensions caused by breach, failed renewal payment, chargeback, unpaid agreed services, payment dispute, security risk, or legal risk."
            },
            {
                "t": "p",
                "text": "Scheduled and emergency maintenance are excluded from downtime calculations. No service credits apply unless agreed in a separate written agreement."
            },
            {
                "t": "p",
                "text": "BOtag may perform maintenance, updates, patches, and improvements. BOtag will provide reasonable notice where practical for maintenance expected to materially affect production availability. Emergency maintenance may be performed without prior notice."
            },
            {
                "t": "p",
                "text": "Support is available through support@bostages.com, in-app support where available, and NanaBO where available. Support is provided during normal Norwegian business hours (09:00-16:00 CET/CEST), Monday to Friday, excluding Norwegian public holidays, unless otherwise agreed in a separate written agreement."
            }
        ]
    },
    {
        "title": "9. Customer Data, PIMP, and outputs",
        "blocks": [
            {
                "t": "p",
                "text": "The Customer owns Customer Data."
            },
            {
                "t": "p",
                "text": "Customer Data may include uploaded files, product masters, order files, EAN/barcode sheets, PDFs, POS payloads, integration data, BOimages, NanaBO messages, PIMP mappings, validation reports, audit logs, generated files, and exports."
            },
            {
                "t": "p",
                "text": "The Customer grants BOtag the rights needed to host, process, store, copy, transform, validate, analyse, generate outputs from, export, secure, support, and operate Customer Data for the purpose of providing the Services."
            },
            {
                "t": "p",
                "text": "BOtag does not modify original uploaded source files as part of normal PIMP processing. BOtag may create normalized BOstages workspace data, mappings, validation reports, audit logs, generated files, exports, and other outputs based on those source files."
            },
            {
                "t": "p",
                "text": "The Customer is responsible for reviewing and approving outputs before importing, exporting, publishing, syncing, or otherwise using them."
            },
            {
                "t": "p",
                "text": "BOtag is not responsible for errors, failed imports, incorrect exports, missing data, duplicate data, product-data errors, barcode errors, price errors, image errors, or integration issues caused by Customer Data, source files, third-party systems, or Customer instructions, unless caused by BOtag's proven breach of these Terms."
            },
            {
                "t": "p",
                "text": "BOtag may reject, quarantine, delete, or restrict files or data that are unsafe, illegal, corrupted, harmful, suspicious, or likely to create security, legal, operational, or platform risk."
            }
        ]
    },
    {
        "title": "10. NanaBO and AI-assisted features",
        "blocks": [
            {
                "t": "p",
                "text": "NanaBO and related AI-assisted features may help with operational workflows, file understanding, mapping support, validation explanations, summaries, product-data review, and support."
            },
            {
                "t": "p",
                "text": "AI-assisted outputs may be incomplete, inaccurate, or unsuitable for a specific purpose. The Customer is responsible for reviewing all outputs before using them."
            },
            {
                "t": "p",
                "text": "The Customer must not use NanaBO or AI-assisted features for legal, medical, financial, tax, accounting, HR, employment, safety-critical, regulated, or other high-risk advice or decision-making."
            },
            {
                "t": "p",
                "text": "BOtag may log NanaBO interactions for support, security, auditability, troubleshooting, service operation, and service improvement according to the Privacy Policy and Data Processing Agreement."
            },
            {
                "t": "p",
                "text": "Where available, Customers may disable NanaBO or AI-assisted features."
            },
            {
                "t": "p",
                "text": "BOtag does not use Customer content to train public AI models unless expressly agreed in writing."
            }
        ]
    },
    {
        "title": "11. Integrations and third-party services",
        "blocks": [
            {
                "t": "p",
                "text": "BOstages may connect with third-party systems such as POS, commerce, payment, accounting, analytics, logistics, AI, retail, and other operational platforms."
            },
            {
                "t": "p",
                "text": "The Customer is responsible for authorising integrations, maintaining credentials, reviewing synced data, and complying with third-party terms."
            },
            {
                "t": "p",
                "text": "BOtag is not responsible for outages, API changes, pricing changes, rate limits, authentication failures, third-party data errors, third-party security incidents, or losses caused by third-party services outside BOtag's reasonable control."
            },
            {
                "t": "p",
                "text": "BOtag may modify, suspend, replace, or discontinue an integration if a third-party API, provider, legal requirement, security issue, technical limitation, or operational risk makes continued support impractical, unsafe, unlawful, or commercially unreasonable."
            },
            {
                "t": "p",
                "text": "Connector and export limitations affect connector output only. They do not automatically change BOtag's internal product-data model or original source records."
            }
        ]
    },
    {
        "title": "12. Acceptable use",
        "blocks": [
            {
                "t": "p",
                "text": "The Customer must not:"
            },
            {
                "t": "ul",
                "items": [
                    "use the Services unlawfully;",
                    "attempt unauthorised or cross-tenant access;",
                    "interfere with or disrupt the Services;",
                    "upload malware, harmful code, illegal content, or unsafe files;",
                    "conduct security testing, scraping, stress testing, or automated abuse without written approval;",
                    "reverse engineer or attempt to extract source code, except where mandatory law permits;",
                    "circumvent access controls, billing controls, usage limits, or security controls;",
                    "resell or sublicense access without approval;",
                    "infringe third-party rights;",
                    "upload data the Customer has no right to use;",
                    "upload unnecessary sensitive personal data;",
                    "use NanaBO or AI features to generate unlawful, harmful, infringing, or high-risk content."
                ]
            },
            {
                "t": "p",
                "text": "BOtag may immediately suspend or restrict access if BOtag reasonably believes this section has been violated."
            }
        ]
    },
    {
        "title": "13. Sensitive data",
        "blocks": [
            {
                "t": "p",
                "text": "BOstages is not designed for unnecessary sensitive personal data."
            },
            {
                "t": "p",
                "text": "The Customer must not upload special-category personal data, national identity numbers, payment-card data, health data, criminal offence data, children's data, biometric data, private HR records, patient data, citizen data, healthcare data, school data, or similar high-risk data unless expressly agreed in writing and legally permitted."
            },
            {
                "t": "p",
                "text": "If such data is uploaded without approval, BOtag may delete, quarantine, restrict, or return it where reasonably necessary."
            }
        ]
    },
    {
        "title": "14. Data protection",
        "blocks": [
            {
                "t": "p",
                "text": "Personal data processing is governed by the BOstages Privacy Policy and, where BOtag processes Customer Personal Data on behalf of the Customer, the BOstages Data Processing Agreement."
            },
            {
                "t": "p",
                "text": "If these Terms conflict with the Data Processing Agreement, the Data Processing Agreement controls only for personal-data processing matters."
            }
        ]
    },
    {
        "title": "15. Intellectual property",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag owns BOstages and all BOtag software, source code, platform architecture, workflows, UI, documentation, APIs, PIMP logic, NanaBO setup, worker logic, templates, schemas, methods, know-how, service improvements, and related intellectual property."
            },
            {
                "t": "p",
                "text": "The Customer receives a limited, non-exclusive, non-transferable right to use the Services during the subscription period according to these Terms and any applicable separate written agreement."
            },
            {
                "t": "p",
                "text": "The Customer owns Customer Data and Customer-owned outputs generated from Customer Data, subject to BOtag's rights in the underlying platform, software, templates, logic, and service components."
            },
            {
                "t": "p",
                "text": "The Customer must not copy, modify, distribute, reverse engineer, sublicense, resell, or create competing services from BOtag intellectual property except as expressly allowed in writing or by mandatory law."
            },
            {
                "t": "p",
                "text": "BOtag may use aggregated or anonymised data for analytics, reporting, benchmarking, service improvement, product development, security, and operational planning, provided it does not identify the Customer, users, or individuals."
            },
            {
                "t": "p",
                "text": "BOtag may use the Customer's name or logo in marketing only with the Customer's permission."
            }
        ]
    },
    {
        "title": "16. Confidentiality",
        "blocks": [
            {
                "t": "p",
                "text": "Each Party shall protect the other Party's confidential information."
            },
            {
                "t": "p",
                "text": "Confidential information includes source code, security information, pricing, commercial terms, business plans, customer files, product data, order data, integration data, technical data, platform architecture, non-public documentation, trade secrets, support communication, personal data, audit logs, and business data."
            },
            {
                "t": "p",
                "text": "Confidentiality obligations survive for 3 years after termination. Trade secrets remain protected for as long as they remain trade secrets under applicable law."
            },
            {
                "t": "p",
                "text": "Confidentiality does not apply to information that is public without breach, already known without restriction, independently developed without use of confidential information, or lawfully received from a third party without confidentiality restriction."
            }
        ]
    },
    {
        "title": "17. Warranties and disclaimers",
        "blocks": [
            {
                "t": "p",
                "text": "Except as expressly stated in these Terms or a separate written agreement, the Services are provided \"as is\" and \"as available.\""
            },
            {
                "t": "p",
                "text": "BOtag does not warrant that the Services will be uninterrupted, error-free, defect-free, compatible with every third-party system, suitable for every Customer purpose, or that PIMP, NanaBO, AI-assisted, import, mapping, validation, or export outputs will always be complete, correct, or suitable."
            },
            {
                "t": "p",
                "text": "The Customer is responsible for determining whether the Services are suitable for its business, data, integrations, and operational needs."
            }
        ]
    },
    {
        "title": "18. Limitation of liability",
        "blocks": [
            {
                "t": "p",
                "text": "To the maximum extent permitted by applicable law, BOtag shall not be liable for indirect, consequential, special, incidental, punitive, or similar losses, including loss of profit, revenue, business, goodwill, anticipated savings, opportunity, reputation, business interruption, data reconstruction costs, third-party claims, or losses caused by Customer Data, Customer instructions, third-party services, Customer integrations, or Customer failure to review outputs."
            },
            {
                "t": "p",
                "text": "BOtag's total aggregate liability arising out of or relating to the Services shall not exceed the fees paid by the Customer to BOtag for the Services giving rise to the claim during the 12 months immediately before the event giving rise to the claim. If the relevant fees cannot reasonably be separated, the cap applies to the subscription fees paid by the Customer during that period."
            },
            {
                "t": "p",
                "text": "Nothing in these Terms limits or excludes liability that cannot be limited under applicable law, the Customer's payment obligations, or liability arising from BOtag's gross negligence (grov uaktsomhet) or wilful misconduct (forsett)."
            }
        ]
    },
    {
        "title": "19. Customer indemnity",
        "blocks": [
            {
                "t": "p",
                "text": "The Customer shall defend, indemnify, and hold BOtag harmless from claims, losses, damages, regulatory penalties to the extent legally indemnifiable, costs, and expenses arising from Customer Data, unlawful use of the Services, breach of these Terms, breach of third-party rights, unauthorised use of product data or images, connected third-party systems, Customer instructions, or Customer failure to review outputs before use."
            },
            {
                "t": "p",
                "text": "This does not apply to the extent the claim is caused by BOtag's proven breach of these Terms."
            }
        ]
    },
    {
        "title": "20. Force majeure",
        "blocks": [
            {
                "t": "p",
                "text": "Neither Party is liable for failure or delay caused by circumstances beyond its reasonable control, including natural disasters, war, terrorism, civil unrest, labour disputes, government action, legal restrictions, internet failures, power failures, cloud provider incidents, third-party service failures, cyberattacks, pandemics, supply-chain issues, or similar events."
            }
        ]
    },
    {
        "title": "21. Changes",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag may improve, modify, replace, update, suspend, or discontinue features, workflows, integrations, UI elements, APIs, or technical components, provided this does not materially reduce the core paid functionality of the affected Services."
            },
            {
                "t": "p",
                "text": "BOtag may update these Terms from time to time. BOtag will provide at least 30 days' notice for material changes unless changes are required sooner for legal, security, operational, or compliance reasons."
            },
            {
                "t": "p",
                "text": "Continued use after updated Terms take effect constitutes acceptance."
            },
            {
                "t": "p",
                "text": "If a material change negatively affects the Customer, the Customer may terminate the affected Services before the change takes effect. Termination prevents renewal but does not entitle the Customer to a refund for the current paid period unless required by law or agreed in writing."
            }
        ]
    },
    {
        "title": "22. Subcontractors and providers",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag may use subcontractors, service providers, and subprocessors to provide the Services."
            },
            {
                "t": "p",
                "text": "Personal data processing by subprocessors is governed by the Data Processing Agreement."
            },
            {
                "t": "p",
                "text": "BOtag may change subcontractors and providers where this does not materially reduce the Services, subject to the DPA where Customer Personal Data is processed."
            }
        ]
    },
    {
        "title": "23. Notices",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag may send notices by email, in-app message, account notification, website notice, invoice message, or other reasonable method."
            },
            {
                "t": "p",
                "text": "Notices to BOtag must be sent to support@bostages.com."
            },
            {
                "t": "p",
                "text": "The Customer is responsible for keeping contact details updated."
            }
        ]
    },
    {
        "title": "24. General terms",
        "blocks": [
            {
                "t": "p",
                "text": "The Parties are independent contractors."
            },
            {
                "t": "p",
                "text": "The Customer may not assign the agreement without BOtag's prior written approval. BOtag may assign the agreement to an affiliate, successor, acquirer, or entity involved in a merger, restructuring, sale of assets, or similar transaction."
            },
            {
                "t": "p",
                "text": "If any provision is invalid or unenforceable, the remaining provisions remain in effect."
            },
            {
                "t": "p",
                "text": "A Party's failure to enforce a provision is not a waiver."
            },
            {
                "t": "p",
                "text": "These Terms and the documents forming the agreement constitute the entire agreement for the Services covered."
            }
        ]
    },
    {
        "title": "25. Electronic acceptance and signatures",
        "blocks": [
            {
                "t": "p",
                "text": "These Terms may be accepted electronically."
            },
            {
                "t": "p",
                "text": "Separate written agreements, DPAs, and related documents may be signed electronically, including through Adobe Sign, DocuSign, clickwrap, or another electronic signature method accepted by BOtag."
            },
            {
                "t": "p",
                "text": "Electronic acceptance and electronic signatures are intended to have the same binding effect as handwritten signatures to the extent permitted by applicable law."
            }
        ]
    },
    {
        "title": "26. Governing law and dispute resolution",
        "blocks": [
            {
                "t": "p",
                "text": "These Terms are governed by, and construed in accordance with, Norwegian law."
            },
            {
                "t": "p",
                "text": "The Parties shall first attempt to resolve any dispute, controversy, or claim arising out of or relating to these Terms through amicable, good-faith negotiations."
            },
            {
                "t": "p",
                "text": "If a dispute is not resolved within 30 days after one Party has notified the other Party of the dispute, the dispute shall be subject to the ordinary courts of Norway, with the Oslo District Court (Oslo tingrett) as the agreed legal venue (avtalt verneting), to the extent permitted by mandatory law."
            },
            {
                "t": "p",
                "text": "Notwithstanding the paragraph above, the Parties may at any time mutually agree in writing to resolve a specific dispute through private arbitration in Oslo, Norway. Unless otherwise agreed, the arbitration language shall be English."
            },
            {
                "t": "p",
                "text": "Either Party may seek temporary, injunctive, or urgent relief from any competent court where necessary to protect confidential information, intellectual property, security, systems, data, or payment rights."
            },
            {
                "t": "p",
                "text": "BOtag may pursue undisputed unpaid amounts, chargebacks, approved manual charges, onboarding fees, project fees, integration fees, custom-work fees, or other agreed payment claims through ordinary collection procedures, enforcement procedures, or competent courts."
            }
        ]
    },
    {
        "title": "27. Short summary",
        "blocks": [
            {
                "t": "p",
                "text": "BOtag may provide a short, non-binding summary of these Terms for convenience. If a summary conflicts with these Terms, these Terms control."
            }
        ]
    }
];
// #endregion
